<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col cols="12" md="10">
                    <b-link :to="{ name: 'settings-teams' }"
                        ><font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>
                    <h1 class="mt-1">
                        {{ $t("mainmenu.settings") }} / {{ $t("settings.teams.Teams") }} /
                        {{ $t("settings.teams.create.title") }}
                    </h1>

                    <hr />

                    <validation-observer v-if="teamData" ref="validationRules" name="team" tag="form">
                        <app-team-info :team-data="teamData" />
                        <app-channels :channels="channels" :team-data="teamData" />
                        <app-users :team-data="teamData" :users="users" />

                        <b-form-group content-cols-lg="7" content-cols-sm label-cols-lg="3" label-cols-sm="4">
                            <b-button
                                :disabled="isSaving"
                                class="d-flex justify-content-center mb-2"
                                variant="primary"
                                @click="create"
                            >
                                <b-spinner v-if="isSaving" class="mr-50" small></b-spinner>
                                {{ $t("settings.teams.create.submit") }}
                            </b-button>
                        </b-form-group>
                    </validation-observer>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { BButton, BCol, BRow, BContainer, BLink, BFormGroup, BSpinner } from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import AppTeamInfo from "./components/teamInfo";
import AppChannels from "./components/channels";
import AppUsers from "./components/users";
import useTeams from "./useTeams";
import { ref } from "@vue/composition-api";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import toastificationContent from "@/layouts/components/toastification/toastificationContent";

export default {
    components: {
        BButton,
        BCol,
        BRow,
        BContainer,
        BLink,
        BFormGroup,
        BSpinner,
        AppTeamInfo,
        AppChannels,
        AppUsers,
        ValidationObserver,
    },
    setup() {
        const toast = useToast();
        const teamData = ref({
            name: "",
            email: "",
            sendNotificationOnNewConversation: "0",
            color: "#000000",
            channels: [],
            users: [],
        });
        const { channels, users, fetchChannels, fetchUsers } = useTeams();
        const isSaving = ref(false);

        fetchChannels({
            fields: "id,name",
        });
        fetchUsers({
            fields: "name",
            s: {
                $and: [{ role: { $ne: "api" } }, { role: { $ne: "saysimple" } }, { active: { $eq: 1 } }],
            },
        });

        return {
            channels,
            users,
            teamData,
            toast,
            isSaving,
        };
    },
    methods: {
        create() {
            return new Promise((resolve, reject) => {
                this.$refs.validationRules.validate().then((success) => {
                    if (success) {
                        const channels = this.teamData.channels.map((id) => ({ id }));
                        const teamUsers = this.teamData.users.map((user) => ({
                            userId: user.id,
                        }));

                        this.isSaving = true;

                        axios
                            .post("teams", {
                                ...this.teamData,
                                channels,
                                teamUsers,
                            })
                            .then(async (result) => {
                                this.$router.push({ name: "settings-teams" }, () => {
                                    this.toast.success(i18n.t("settings.teams.created.success.description"));
                                });
                                resolve(result.data);
                            })
                            .catch(() => {
                                this.toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("settings.teams.Add team"),
                                        text: i18n.t("toast.create.error", { entity: i18n.t("settings.teams.Team") }),
                                        icon: "exclamation-triangle",
                                        variant: "warning",
                                    },
                                });

                                reject();
                            })
                            .finally(() => (this.isSaving = false));
                        resolve();
                    } else {
                        reject();
                    }
                });
            }).catch(() => {
                this.toast({
                    component: toastificationContent,
                    props: {
                        title: i18n.t("settings.teams.Add team"),
                        text: i18n.t("toast.create.error", { entity: i18n.t("settings.teams.Team") }),
                        icon: "exclamation-triangle",
                        variant: "warning",
                    },
                });
            });
        },
    },
};
</script>
